<template>
  <div>

      <p>
        {{
          ft(featureName, 'create.ingress', $t, {
            organizationTitle: organizationFullName
          })
        }}
      </p>
      <h5>
        {{ ft(featureName, 'create.instructionsHeader', $t) }}
      </h5>
      <p>
        <ul v-for="instruction in instructions" :key="instruction" class="mt-3">
          <li>
            {{ instruction }}
          </li>
        </ul>
      </p>
      <b-list-group v-if="organizationLinks" class="mb-4 mt-2">
        <b-list-group-item
          v-for="linkName in Object.keys(organizationLinks)"
          :key="linkName"
        >
          <a
            :href="organizationLinks[linkName].href"
            target="_blank"
            class="org-link"
          >
            {{ organizationLinks[linkName].title }}
          </a>
        </b-list-group-item>
      </b-list-group>
      <puls-form-radio v-model="selectedReportingChannel" :options="reportingChannels"  />
      <digital-report-form
        v-if="selectedReportingChannel === 'digital-report'"
        :initial-form-data="initialFormData"
        :on-change="changeFormReport"
        :feature-name="featureName"
      >
      </digital-report-form>

      <physical-meeting-form
        v-if="selectedReportingChannel === 'physical-meeting'"
        :initial-form-data="initialFormData"
        :on-change="changeFormReport"
        :feature-name="featureName"
      >
      </physical-meeting-form>
      <phone-call-form
        v-if="selectedReportingChannel === 'phone-call'"
        :initial-form-data="initialFormData"
        :on-change="changeFormReport"
        :feature-name="featureName"
      >
      </phone-call-form>
  
  </div>
</template>

<script>
import LocalizableComponent from './LocalizableComponent.vue'
import DigitalReportForm from './DigitalReportForm.vue'
import PhysicalMeetingForm from './PhysicalMeetingForm.vue'
import PhoneCallForm from './PhoneCallForm.vue'

export default {
  name: 'CreateReportForm',
  components: {
    DigitalReportForm,
    PhysicalMeetingForm,
    PhoneCallForm
  },
  extends: LocalizableComponent,
  props: {
    onChange: {
      type: Function,
      default: () => {}
    },
    organizationFullName: {
      type: String,
      default: ''
    },
    organizationLinks: {
      type: Object,
      default: null
    },
    initialFormData: {
      type: Object,
      default: null
    },
    initialReportingChannel: {
      type: String,
      default: 'digital-report'
    },
    featureName: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
  
      selectedReportingChannel: 'digital-report'
    }
  },
  computed: {
    reportingChannels() {
      const filteredChannels = Object.keys(
        this.featureToggles[this.featureName].reportingChannel
      )
        .map(channel => {
          const c = this.featureToggles[this.featureName].reportingChannel[
            channel
          ]
          return {
            channel, // camelCase
            ...c,
             value: c.name,
            title:  this.ft(this.featureName, `reportingChannels.${channel}.label`, this.$t)
          }
        })
        .filter(c => c.enabled)
      return filteredChannels.length > 1 ? filteredChannels : [] // if there's only no channel we dont care about displaying it
    },
    instructions() {
      return [
        this.ft(this.featureName, 'create.instructions', this.$t, {
          organizationTitle: this.organizationFullName
        }),
        this.ft(this.featureName, 'create.instructions1', this.$t, {
          organizationTitle: this.organizationFullName
        }),
        this.ft(this.featureName, 'create.instructions2', this.$t, {
          organizationTitle: this.organizationFullName
        })
      ]
    }
  },
  watch: {
    selectedReportingChannel() {
      this.onChange({
        selectedChannel: this.selectedReportingChannel,
        validForm: this.validForm,
        formData: this.formData
      })
    }
  },
  mounted() {
    this.formData = this.initialFormData
    this.selectedReportingChannel = this.initialReportingChannel
  },
  methods: {
    changeFormReport(params) {
      this.onChange({
        selectedChannel: this.selectedReportingChannel,
        ...params
      })
    }
  }
}
</script>
<style scoped>
.org-link {
  color: rgb(120, 90, 31);
  text-decoration: underline;
}

.instructions-header {
  font-weight: 500;
}

.reporting-channel-option {
  color: rgb(70, 70, 70);
  font-size: 15px;
}
</style>
